var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),_c('div',{class:{
      'd-flex align-top': true,
      'justify-center w-100': _vm.$vuetify.breakpoint.smAndDown,
      'group-buttons-containter-lg': _vm.$vuetify.breakpoint.mdAndUp,
    }},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.$emit('add-condition')}}},[_c('v-icon',{attrs:{"color":"#2b84eb","small":""}},[_vm._v(" mdi-plus ")])],1),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.$emit('remove-condition')}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v(" mdi-delete-outline ")])],1)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }